/*
 * @Author: yeild
 * @Date: 2021-08-23 21:25:50
 */
import { StateType } from '/@/store/types'
import { Module } from 'vuex'

const state = {
  backdoor: false, //仅用于本地测试的开关（发布上线时请改为false）
}
type SystemStateType = typeof state

const system: Module<SystemStateType, StateType> = {
  namespaced: true,
  ...state,
}

export { SystemStateType, state }
export default system
